import '../../common/bn-loading';
import './work-order-view';
import { BnModalMixin } from '../../common/bn-modal-mixin';
import { html, LitEntity } from '../../utility/lit-entity';

class WorkOrderViewModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'work-order-view-modal';
  }

  renderContents() {
    return html`
      <style>
        bn-modal#${this.id} {
          --modal-min-width: 80%;
          --modal-max-width: 80%;
          --modal-body-overflow-y: auto;
        }
      </style>
      <h3 slot="title">Work Order #${this.getProperty('referenceId')}</h3>
      <work-order-view .href="${this.href}"></work-order-view>
    `;
  }
}

window.customElements.define('work-order-view-modal', WorkOrderViewModal);
